import { render, staticRenderFns } from "./CreateOrderModal.vue?vue&type=template&id=8363e604&scoped=true&"
import script from "./CreateOrderModal.vue?vue&type=script&lang=js&"
export * from "./CreateOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CreateOrderModal.vue?vue&type=style&index=1&id=8363e604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8363e604",
  null
  
)

export default component.exports